import { createI18n } from 'vue-i18n';
import en from '@/locales/en.json';
import pt from '@/locales/pt.json';

const url = new URL(window.location.href);
const lang = url.searchParams.get('lang');

let locale: string;

if (lang) {
    locale = lang;
} else {
    locale = window.localStorage.getItem('locale') || 'en';
}

const i18n = createI18n({
    // Disable legacy API:
    legacy: false, // you must set `false`, to use Composition API
    // If you still want `<template>{{ $t('msg') }}</template>` to work:
    globalInjection: true,
    fallbackLocale: 'en',
    locale: locale,
    messages: {
        en,
        pt,
    },
    numberFormats: {
        en: {
            money: {
                style: 'decimal',
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
        pt: {
            money: {
                style: 'decimal',
                useGrouping: true,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            },
        },
    },
});

export default i18n;
